import { pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/lib/TaskEither';
import { formCodec } from './codec';
import {
  createAuthorizedPostRequest,
  decodeId,
  fetchApi,
  setBody,
} from '../..';

const baseUrl = '/v2/profile/bug-reports';

export const create = (subject: string, description?: string, screenRecording?: string) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody(formCodec.encode({ subject, description, screenRecording }))),
  chain(fetchApi),
  chain(decodeId),
);
